import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate107.scss';

import React from 'react';
import { cn } from '../../../utils/bem';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { Typography } from '@dataartdev/uikit/Typography';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { cnContentBuilderTemplate } from './index';
import { Slider, SliderItem } from '@dataartdev/uikit/Slider';
import { Link } from '@dataartdev/uikit/Link';
import { Picture } from '@dataartdev/uikit/Picture';
import { Avatar } from '@dataartdev/uikit/Avatar';
import { IRoot107 } from './models/CTI_107.props';
import { clearFalsyProps } from '../../../utils';
import { Link as ReactLink } from 'react-router-dom';

const cnPartnersLogotypes = cn('PartnersLogotypes');
const cnPartnersLogotypeSlide = cn('PartnersLogotypeSlide');

const sliderConfig = {
  watchOverflow: true,
  navigation: false,
  pagination: {
    clickable: true,
  },
  slidesPerView: 1,
  spaceBetween: 40,
};

export const ContentBuilderTemplate: React.FC<IRoot107> = props => {
  const {
    type,
    link,
    title,
    clients,
    testimonials,
    contentId,
  } = usePropsHandler(cnContentBuilderTemplate(), props);

  const typeNumber = type.toString();

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <div className={cnPartnersLogotypes()}>
        {(title || link) && (
          <div className={cnPartnersLogotypes('Headline')}>
            {title && (
              <Typography.Title size="lg" as="h2">
                {title}
              </Typography.Title>
            )}
            {link?.link && link?.title && (
              <Link
                href={link.link}
                className={cnPartnersLogotypes('View-All')}
              >
                {link.title}
              </Link>
            )}
          </div>
        )}
        <Grid
          breakpoints={{
            desktop: { cols: 12, gap: 'xl' },
            tablet: { cols: 12, gap: 'xl' },
            mobile: { cols: 12, gap: 'xl' },
          }}
          className={cnPartnersLogotypes('Inner')}
        >
          <GridItem
            breakpoints={{
              desktop: { col: 6 },
              tablet: { col: 6 },
              mobile: { col: 12 },
            }}
            className={cnPartnersLogotypes('Logos')}
          >
            {clients && clients.length > 0 && (
              <Grid
                breakpoints={{
                  desktop: { cols: 12, gap: 'xl' },
                  tablet: { cols: 12, gap: 'xl' },
                  mobile: { cols: 12, gap: 'xl' },
                }}
                className={cnPartnersLogotypes('Logos-Inner')}
              >
                {clients.map(client => {
                  const logoAttr = {
                    type: client?.logo?.type,
                    name: client?.logo?.name,
                    alt: client?.logo?.alt,
                    url: client?.logo?.url,
                    urlWebp: client?.logo?.urlWebp,
                  };
                  return (
                    <GridItem
                      key={client.id}
                      breakpoints={{
                        desktop: { col: 6 },
                        tablet: { col: 6 },
                        mobile: { col: 6 },
                      }}
                      className={cnPartnersLogotypes('Logo')}
                    >
                      {Object.keys(clearFalsyProps(logoAttr)).length > 0 &&
                        (client?.relativeUrl ? (
                          <ReactLink to={client?.relativeUrl || '#'}>
                            <Picture {...logoAttr} />
                          </ReactLink>
                        ) : (
                          <Picture {...logoAttr} />
                        ))}
                    </GridItem>
                  );
                })}
              </Grid>
            )}
          </GridItem>
          {testimonials && testimonials.length > 0 && (
            <GridItem
              breakpoints={{
                desktop: { col: 6 },
                tablet: { col: 6 },
                mobile: { col: 12 },
              }}
              className={cnPartnersLogotypes('Promo')}
            >
              <Slider
                {...sliderConfig}
                className={cnPartnersLogotypes('Carousel')}
              >
                {testimonials.map(testimonial => {
                  const {
                    quote = '',
                    authorPhoto,
                    author = '',
                    authorPosition = '',
                    logo,
                  } = testimonial || {};

                  const logoAttr = {
                    urlWebp: logo?.urlWebp,
                    url: logo?.url,
                    name: logo?.name,
                    alt: logo?.alt,
                    typ: logo?.type,
                  };
                  const authorFotoAttr = {
                    url: authorPhoto?.urlWebp || authorPhoto?.url,
                    name: authorPhoto?.name,
                    size: authorPhoto?.size,
                  };
                  return (
                    <SliderItem key={testimonial.id}>
                      <div className={cnPartnersLogotypeSlide()}>
                        {Object.keys(clearFalsyProps(logoAttr)).length > 0 && (
                          <Picture
                            {...logoAttr}
                            className={cnPartnersLogotypeSlide('Logo')}
                          />
                        )}
                        {quote && (
                          <Typography.Text
                            parse
                            as="p"
                            size="l"
                            className={cnPartnersLogotypeSlide('Text')}
                          >
                            {quote}
                          </Typography.Text>
                        )}
                        <div className={cnPartnersLogotypeSlide('Author')}>
                          {authorPhoto && author && (
                            <Avatar
                              {...authorFotoAttr}
                              name={author}
                              size="m"
                            />
                          )}
                          {(author || authorPosition) && (
                            <div
                              className={cnPartnersLogotypeSlide('Author-Info')}
                            >
                              {author && (
                                <Typography.Text
                                  as="span"
                                  size="l"
                                  weight="bold"
                                >
                                  {author}
                                </Typography.Text>
                              )}
                              {authorPosition && (
                                <Typography.Text as="span" size="l">
                                  {authorPosition}
                                </Typography.Text>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </SliderItem>
                  );
                })}
              </Slider>
            </GridItem>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default ContentBuilderTemplate;
